export default {
  text: {
    en: 'No guess work, they choose the perfume or cologne they want',
  },
  buttonTitle: {
    en: 'Buy gift now',
  },
}
